import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-registration",
  "use": "icon-mobile-registration-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-mobile-registration\">\r\n<path stroke=\"rgba(104, 117, 131, 1)\" stroke-width=\"1.3333333730697632\" stroke-linejoin=\"round\" stroke-linecap=\"round\" style=\"mix-blend-mode:normal\" d=\"M13.3464 7.33333L13.3464 14L2.67969 14L2.67969 7.33333\">\r\n</path>\r\n<path d=\"M1.94744 4.5922C1.43759 5.91257 2.42102 7.33333 3.8364 7.33333C4.94097 7.33333 5.84253 6.4379 5.84253 5.33333C5.84253 6.4379 6.73797 7.33333 7.84253 7.33333L8.182 7.33333C9.28657 7.33333 10.182 6.4379 10.182 5.33333C10.182 6.4379 11.0839 7.33333 12.1885 7.33333C13.6046 7.33333 14.589 5.91173 14.0787 4.59077L13.0779 2L2.94841 2L1.94744 4.5922Z\" stroke=\"rgba(104, 117, 131, 1)\" stroke-width=\"1.3333333730697632\" stroke-linejoin=\"round\" style=\"mix-blend-mode:normal\">\r\n</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mobile-registration.svg
// module id = 83Q1
// module chunks = 115